import { h } from 'preact';
import { useEffect } from 'preact/hooks';

export const Klarna = ({ price }) => {
  if (!price) return null;
  const { amount } = price;

  useEffect(() => {
    if (window.Klarna?.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  }, [price]);

  return (
    <klarna-placement
      data-key="credit-promotion-auto-size"
      data-locale="en-CA"
      data-purchase-amount={amount * 100}
      data-theme="light"
    ></klarna-placement>
  );
};
